export default {
    "just_now": "الان",
    "minutes_ago": "منذ {0} دقائق",
    "hours_ago": "منذ {0} ساعات",
    "days_ago": "منذ {0} أيام",
    "months_ago": "منذ {0} أشهر",
    "years_ago": "منذ {0} سنوات",
    "less_than_minute": "أقل من دقيقة",
    "minutes_duration": "{0} دقائق",
    "hours_duration": "{0} ساعات",
    "days": "أيام",
    "all": " الكل ",
    "seller": " البائع ",
    "buyer": " المشتري ",
    "general-tips": "نصائح عام ",
    "search": "بحث",
    "message-text": "رسالة...",
    "response_estimated": "الوقت المقدر للاستجابة خلال {0}",
    "response_time": "وقت الاستجابة",
    "block_user": "حظر المستخدم",
    "delete-room": "حذف المحادثة",
    "confirmation_question-blocked": "هل أنت متأكد من حظر المستخدم",
    "confirmation_question-delete-chat": "هل أنت متأكد من حذف المحادثة",
    "yes": "نعم",
    "no": "لا",
    "download": "تحميل",
    "no_chats_messages": "لا يوجد رسائل",
    "internet_not_connected_title": "الجهاز غير متصل",
    "internet_not_connected_description": "تأكد من أن الجهاز متصل بالإنترنت.",
    "not_connected_offline": "أنـت غـير مـتصل",
    "not_connected_check": "تأكد من اتصالك بالانترنت او حاول مرة اخرى",
    "try_again": "حاول مجددا",
    "typing": "...يكتـب الآن",
    "ADD_VIN_NUMBER": "أضف رقم الشاصي",
    "ASK_FOR_PRICE": "أضف السعر",
    "ASK_FOR_DROP_PRICE": "أخفض السعر",
    "ASK_FOR_IMAGE": "أضف صور",
    "ASK_FOR_MAP": "أضف الخريطة",
    "APPLY_TO_JOB": "إقرأ السيرة الذاتية",
    "ASK_FOR_PRICE_S2B_BUYER": "أظهر السعر",
    "ASK_FOR_DROP_PRICE_S2B": "أظهر السعر",
    "ASK_FOR_VIN_S2B": "أظهر رقم الشاصي",
    "ASK_FOR_LOCATION_S2B": "أظهر الخريطة",
    "ASK_FOR_IMAGE_S2B": "أظهر الصور",
    'ASK_FOR_VIDEO_S2B': "أظهر الفيديو",
    'ASK_FOR_VIDEO': "أضف فيديو"
};
